// ReSharper disable All
window.alert = (function () {
    var nativeAlert = window.alert;
    return function (message) {
        window.alert = nativeAlert;
        if (message) {
            if (message.indexOf("DataTables warning") > -1 ||
                message.indexOf("e.clear") > -1 ||
                message.indexOf("X.clear") > -1) {
                console.warn(message);
            }
            else {
                nativeAlert(message);
            }
        }
    };
})();
if (!String.prototype.startsWith) {
    Object.defineProperty(String.prototype, "startsWith", {
        value: function (searchString, position) {
            position = position || 0;
            return this.substr(position, searchString.length) === searchString;
        }
    });
}
